import { useState } from 'react'
import useBodyScrollLock from '../../hooks/useBodyScrollLock'
import './Navbar.css'

/* ── Icônes SVG inline ── */
const IconSearch = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
    <circle cx="11" cy="11" r="7"/><path d="M21 21l-4.3-4.3"/>
  </svg>
)
const IconHeart = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 21s-7-4.35-9.5-8.5C.5 8.5 2.5 5 6 5c2 0 3.5 1.2 4 2.3.5-1.1 2-2.3 4-2.3 3.5 0 5.5 3.5 3.5 7.5C19 16.65 12 21 12 21z"/>
  </svg>
)
const IconUser = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="8" r="3.5"/><path d="M5 20c0-3.6 3.1-6 7-6s7 2.4 7 6"/>
  </svg>
)
const IconCart = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round">
    <path d="M3 4h2l2.4 12.4a2 2 0 0 0 2 1.6h7.2a2 2 0 0 0 2-1.6L20 8H6"/>
    <circle cx="9" cy="20" r="1"/><circle cx="17" cy="20" r="1"/>
  </svg>
)
const IconDashboard = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="3" width="7" height="7" rx="1"/><rect x="14" y="3" width="7" height="7" rx="1"/>
    <rect x="3" y="14" width="7" height="7" rx="1"/><rect x="14" y="14" width="7" height="7" rx="1"/>
  </svg>
)
const IconMenu = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
    <path d="M3 6h18M3 12h18M3 18h18"/>
  </svg>
)
const IconClose = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
    <path d="M18 6L6 18M6 6l12 12"/>
  </svg>
)
const IconPlus = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round">
    <line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/>
  </svg>
)
const IconShield = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
  </svg>
)
const IconCheck = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="20 6 9 17 4 12"/>
  </svg>
)

/* ── Modale "Publier une annonce" ── */
function PublishModal({ onClose, onAuthClick }) {
  return (
    <div className="nav-modal-overlay" onClick={onClose}>
      <div className="nav-modal" onClick={e => e.stopPropagation()}>
        <button className="nav-modal-close" onClick={onClose} aria-label="Fermer">
          <IconClose />
        </button>
        <div className="nav-modal-icon">
          <IconShield />
        </div>
        <h3 className="nav-modal-title">Publier une annonce</h3>
        <p className="nav-modal-desc">
          Toute annonce soumise sur notre plateforme est{' '}
          <strong>examinée et approuvée par notre équipe</strong> avant d'être
          publiée. Ce processus garantit la qualité, la fiabilité et la
          sécurité des adoptions pour tous nos utilisateurs.
        </p>
        <ul className="nav-modal-list">
          <li><span className="nav-modal-check"><IconCheck /></span>Vérification des informations de l'annonce</li>
          <li><span className="nav-modal-check"><IconCheck /></span>Validation des photos et de la description</li>
          <li><span className="nav-modal-check"><IconCheck /></span>Réponse sous 24h ouvrées après soumission</li>
        </ul>
        <div className="nav-modal-note">
          Un compte est nécessaire pour soumettre une annonce.
        </div>
        <button
          className="nav-modal-cta"
          onClick={() => { onClose(); onAuthClick() }}
        >
          <IconUser />
          Se connecter pour publier
        </button>
      </div>
    </div>
  )
}

/* ── Composant principal ── */
export default function Navbar({
  searchValue      = '',
  onSearchChange   = () => {},
  onSearchSubmit   = () => {},
  wishlistCount    = 0,
  cartCount        = 0,
  user             = { name: '', email: '', role: '', loggedIn: false },
  onLogoClick      = () => {},
  onFavoritesClick = () => {},
  onCartClick      = () => {},
  onAuthClick      = () => {},
  onDashboardClick = () => {},
  onProfileClick   = () => {},
  onContactClick   = () => {},
  onServicesClick  = () => {},
  onPublishClick   = () => {},
  notifBadge       = 0,
}) {
  const [menuOpen,    setMenuOpen]    = useState(false)
  const [publishOpen, setPublishOpen] = useState(false)

  useBodyScrollLock(publishOpen)

  const isAdmin  = user.loggedIn && user.role === 'admin'
  const isUser   = user.loggedIn && user.role !== 'admin'
  const isLogged = user.loggedIn

  return (
    <>
      <nav className="nav">
        <div className="nav-inner">

          {/* Logo */}
          <div className="nav-logo" onClick={onLogoClick}>
            <img
              className="nav-logo-img"
              src={require('../../assets/monlogo.jpeg')}
              alt="Animaux pour Adoption"
              onError={(e) => { e.target.style.display = 'none' }}
            />
            <div className="nav-logo-txt">
              <span className="nav-logo-main">Animaux pour Adoption</span>
              <span className="nav-logo-sub">de la France</span>
            </div>
          </div>

          {/* Recherche desktop */}
          <div className="nav-search">
            <input
              className="nav-search-input"
              type="text"
              placeholder="Rechercher une race, une ville…"
              value={searchValue}
              onChange={(e) => onSearchChange(e.target.value)}
              onKeyDown={(e) => e.key === 'Enter' && onSearchSubmit()}
            />
            <button className="nav-srch-btn" onClick={onSearchSubmit}>
              <IconSearch />
            </button>
          </div>

          {/* Actions desktop */}
          <div className="nav-actions">

            {/* Nos services — toujours visible */}
            <button className="nav-btn nav-btn-contact" onClick={onServicesClick}>
              Nos services
            </button>

            {/* Nous contacter — toujours visible */}
            <button className="nav-btn nav-btn-contact" onClick={onContactClick}>
              Nous contacter
            </button>

            {/* Publier une annonce — toujours visible */}
            <button className="nav-btn-publish" onClick={() => {
              if (isLogged) { onPublishClick() }
              else { setPublishOpen(true) }
            }}>
              <IconPlus />
              Publier
            </button>

            {/* Favoris — connectés uniquement */}
            {isLogged && (
              <button className="nav-btn nav-btn-fav" onClick={onFavoritesClick}>
                <IconHeart />
                Favoris
                {wishlistCount > 0 && <span className="nav-badge">{wishlistCount}</span>}
              </button>
            )}

            {/* Panier — connectés uniquement */}
            {isLogged && (
              <button className="nav-btn nav-icon-btn" onClick={onCartClick}>
                <IconCart />
                Panier
                {cartCount > 0 && <span className="nav-badge">{cartCount}</span>}
              </button>
            )}

            {/* Bouton contextuel selon le rôle */}
            {isAdmin ? (
              <button className="nav-btn-dashboard" onClick={onDashboardClick} style={{ position:'relative' }}>
                <IconDashboard />
                Tableau de bord
                {notifBadge > 0 && (
                  <span style={{ position:'absolute', top:-6, right:-6, background:'#b50b19', color:'#fff', borderRadius:'50%', width:18, height:18, fontSize:10, fontWeight:700, display:'flex', alignItems:'center', justifyContent:'center', border:'2px solid #fff', lineHeight:1 }}>
                    {notifBadge > 99 ? '99+' : notifBadge}
                  </span>
                )}
              </button>
            ) : isUser ? (
              <button className="nav-btn-dashboard" onClick={onProfileClick} style={{ position:'relative' }}>
                <IconDashboard />
                Mon espace
                {notifBadge > 0 && (
                  <span style={{ position:'absolute', top:-6, right:-6, background:'#b50b19', color:'#fff', borderRadius:'50%', width:18, height:18, fontSize:10, fontWeight:700, display:'flex', alignItems:'center', justifyContent:'center', border:'2px solid #fff', lineHeight:1 }}>
                    {notifBadge > 99 ? '99+' : notifBadge}
                  </span>
                )}
              </button>
            ) : (
              <button className="nav-btn" onClick={onAuthClick}>
                <IconUser />
                Connexion
              </button>
            )}
          </div>

          {user.loggedIn && user.isActive === false && (
            <div className="nav-ban-banner" style={{
              width:'100%',
              padding:'10px 14px',
              background:'#fee2e2',
              color:'#991b1b',
              border:'1px solid #fecaca',
              borderRadius:12,
              marginTop:12,
              fontSize:13,
              textAlign:'center',
            }}>
              Votre compte est banni. Vous ne pouvez pas effectuer d'actions tant que le bannissement n'est pas levé.
            </div>
          )}

          {/* Burger mobile */}
          <button
            className="nav-burger"
            onClick={() => setMenuOpen(!menuOpen)}
            aria-label="Menu"
          >
            {menuOpen ? <IconClose /> : <IconMenu />}
          </button>
        </div>

        {/* Menu mobile */}
        {menuOpen && (
          <div className="nav-mobile-menu">
            <div className="nav-mobile-search">
              <input
                type="text"
                placeholder="Rechercher une race, une ville…"
                value={searchValue}
                onChange={(e) => onSearchChange(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === 'Enter') { onSearchSubmit(); setMenuOpen(false) }
                }}
              />
              <button onClick={() => { onSearchSubmit(); setMenuOpen(false) }}>
                <IconSearch />
              </button>
            </div>

            {/* Nos services */}
            <button className="nav-mobile-item nav-mobile-contact" onClick={() => { onServicesClick(); setMenuOpen(false) }}>
              Nos services
            </button>

            {/* Nous contacter */}
            <button className="nav-mobile-item nav-mobile-contact" onClick={() => { onContactClick(); setMenuOpen(false) }}>
              Nous contacter
            </button>

            {/* Publier une annonce */}
            <button className="nav-mobile-item nav-mobile-publish" onClick={() => {
              setMenuOpen(false)
              if (isLogged) { onPublishClick() }
              else { setPublishOpen(true) }
            }}>
              <IconPlus />
              Publier une annonce
            </button>

            {/* Favoris — connectés uniquement */}
            {isLogged && (
              <button className="nav-mobile-item" onClick={() => { onFavoritesClick(); setMenuOpen(false) }}>
                <IconHeart />
                Favoris
                {wishlistCount > 0 && <span className="nav-fav-badge">{wishlistCount}</span>}
              </button>
            )}

            {/* Panier — connectés uniquement */}
            {isLogged && (
              <button className="nav-mobile-item" onClick={() => { onCartClick(); setMenuOpen(false) }}>
                <IconCart />
                Panier
                {cartCount > 0 && <span className="nav-fav-badge">{cartCount}</span>}
              </button>
            )}

            {isAdmin ? (
              <button className="nav-mobile-item nav-mobile-dashboard" onClick={() => { onDashboardClick(); setMenuOpen(false) }} style={{ position:'relative' }}>
                <IconDashboard /> Tableau de bord
                {notifBadge > 0 && <span className="nav-fav-badge">{notifBadge > 99 ? '99+' : notifBadge}</span>}
              </button>
            ) : isUser ? (
              <button className="nav-mobile-item nav-mobile-dashboard" onClick={() => { onProfileClick(); setMenuOpen(false) }} style={{ position:'relative' }}>
                <IconDashboard /> Mon espace
                {notifBadge > 0 && <span className="nav-fav-badge">{notifBadge > 99 ? '99+' : notifBadge}</span>}
              </button>
            ) : (
              <button className="nav-mobile-item" onClick={() => { onAuthClick(); setMenuOpen(false) }}>
                <IconUser /> Connexion
              </button>
            )}
          </div>
        )}
      </nav>

      {/* Modale publication */}
      {publishOpen && (
        <PublishModal
          onClose={() => setPublishOpen(false)}
          onAuthClick={onAuthClick}
        />
      )}
    </>
  )
}